import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const fieldTemplateService = {
  getFieldsForPage: async (user, pageId) => {
    return await axios.get(`${NODE_BASE_URL}/template/field/page/${pageId}`, getAxiosOptions(user))
  },
  getConditionalEnableDisable: async (user, activityTemplateId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/field/field-conditional-enabling/activity/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getFieldConstraints: (user, activityTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/field/field-constraints/activity/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getSubfieldsOfTableField: (user, tableId) => {
    return axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/subfields/${tableId}`,
      getAxiosOptions(user)
    )
  },
  getHiddenFieldsForUser: (user, activityTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/user/user-detail/hidden-fields-for-user/${activityTemplateId}/${user.id}`,
      getAxiosOptions(user)
    )
  },
  getTableConstraints: (user, activityTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/field/table-constraints/activity/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getAllPivotFieldsInProcess: (user, processTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/field/pivot-fields/${processTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getHighLightConstraints: (user, activityTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/field/field-highlighting/activity/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getAllFieldsInActivity: (user, activityTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/field/all-table-subfields/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getTableSubfieldsMapInActivity: (user, activityTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/field/table-subfields-map/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getPivotFieldRestrictions: (user, activityTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/field/pivot-filter-fields/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getTableSubfields: (user, activityTemplateId) => {
    return axios.get(
      `${NODE_BASE_URL}/template/field/table-subfields/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getFieldConstraintHiddenRoute: (user) => {
    return axios.get(
      `${NODE_BASE_URL}/data-entry/process-data/get-hidden-route-field-constraint-map`,
      getAxiosOptions(user)
    )
  },
  addUpdateFieldConstraintHiddenRoute: (user, routeId, data) => {
    return axios.post(
      `${NODE_BASE_URL}/data-entry/process-data/hidden-route-field-constraint-map/${routeId}`,
      data,
      getAxiosOptions(user)
    )
  },
  updateFieldTemplate: async (user, fieldProps) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/template/field/property`,
        fieldProps,
        getAxiosOptions(user)
      )
    ).data
  },
  updateSequences: async (user, data) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/template/field/update-sequences`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },
  updateFieldTemplateOnce: async (user, data) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/template/field/update-field-template`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },
  addFieldTemplate: async (user, fieldDetails) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/`,
        fieldDetails,
        getAxiosOptions(user)
      )
    ).data
  },
  addSubfieldTemplate: async (user, fieldDetails) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/subfield`,
        fieldDetails,
        getAxiosOptions(user)
      )
    ).data
  },
  getActivityFieldsForAdmin: async (user, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/field/activity/${activityTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getDerivableFieldsForProcess: async (user, processTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/field/derivable/${processTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getImportedField: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/template/field/company`, getAxiosOptions(user))).data
  },
  addConditionalEnableDisable: async (user, id, constraints) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/field/conditional-enable-disable/${id}`,
        constraints,
        getAxiosOptions(user)
      )
    ).data
  },
  addAggregationTable: async (user, constraints) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/aggregation-table-config`,
        constraints,
        getAxiosOptions(user)
      )
    ).data
  },
  getAggregationTableData: async (user, id) => {
    return await axios.get(
      `${NODE_BASE_URL}/admin/template/field/aggregation-table-config/${id}`,
      getAxiosOptions(user)
    )
  },
  addFieldConstraints: async (user, id, constraints) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/field/field-constraint/${id}`,
        constraints,
        getAxiosOptions(user)
      )
    ).data
  },
  addTableFieldConstraints: async (user, id, constraints) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/field/table-field-constraint/${id}`,
        constraints,
        getAxiosOptions(user)
      )
    ).data
  },
  deleteConditionalEnableDisable: async (user, id) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/template/field/conditional-enable-disable/${id}`,
        getAxiosOptions(user)
      )
    ).data
  },

  // field protection
  getFieldProtectionConstraints: async (user, id) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/field/protected-field-constraints/${id}`,
        getAxiosOptions(user)
      )
    ).data
  },
  addFieldProtectionConstraints: async (user, id, body) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/field/protected-field-constraints/${id}`,
        body,
        getAxiosOptions(user)
      )
    ).data
  },
  getPivotFieldFilters: async (user, pivotFieldTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/field/pivot-filter-fields/pivot-field/${pivotFieldTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  setPivotFieldFilters: async (user, pivotFieldTemplateId, filters) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/field/pivot-filter-fields/pivot-field/${pivotFieldTemplateId}`,
        filters,
        getAxiosOptions(user)
      )
    ).data
  },

  /* Tables sequences and headers. */
  getTableSequenceAndHeaders: async (user, process_id) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/field/table_sequence_and_headers/${process_id}`,
        getAxiosOptions(user)
      )
    ).data
  },
  updateTableSequenceAndHeaders: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/field/update_table_sequence_and_headers`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },
  updateMultipleTableSequenceAndHeaders: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/field/update_multiple_table_sequence_and_headers`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },

  /* prevent process creation */
  getPreventProcessCreationConfig: async (user, pivotFieldTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/template/field/prevent-process-creation/${pivotFieldTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  setPreventProcessCreationConfig: async (user, pivotFieldTemplateId, data) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/field/prevent-process-creation/${pivotFieldTemplateId}`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },
}
